<h1 mat-dialog-title> Crear Carga </h1> <br/>

<form #cargaForm = ngForm>

    <mat-dialog-content>
        
        <p> <mat-label> <h2> Datos Carga </h2> </mat-label> </p>

          
      
    <p>
        <mat-form-field appearance = "outline" class = "mat-input"> 
                    <input type="text"
                    name = "user"
                    #user = "ngModel"
                    placeholder="Ingrese el nombre del usuario titular"
                    aria-label="Number"
                    matInput
                    [(ngModel)]="termino"
                    [matAutocomplete]="auto"
                    required
                    (input)="buscandor()">    
                    <mat-autocomplete autoActiveFirstOption 
                    #auto="matAutocomplete"
                    (optionSelected)="opcionSeleccionada( $event )">

                    <mat-option *ngFor="let user of  data.usuarios" [value]="user.nombres +' ' +  user.apellidoPaterno+' , ' +  user.rut+'-' +user.dv">
                    {{ user.nombres }} {{ user.apellidoPaterno }}
                    </mat-option>                  
                    </mat-autocomplete>
                </mat-form-field>
            </p>     
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Nombre </mat-label>
                
                <input name = "nombre" matInput [(ngModel)] = "carga.nombre" #nombre = "ngModel" required autofocus />

            </mat-form-field>
        </p>
        
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Apellido </mat-label>
                
                <input name = "apellido" matInput [(ngModel)] = "carga.apellido" required 
                #apellido = "ngModel" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> RUT </mat-label>
                
                <input name = "rut" matInput [(ngModel)] = "carga.rut" required placeholder = "Formato: 11111111-1"
                pattern = "[0-9.]{7,10}[-]{1}[0-9Kk]{1}" #rut = "ngModel" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Tipo Carga </mat-label>
                
                <mat-select name = "tipoCarga" #tipoCarga = "ngModel" [(ngModel)] = "carga.tipoCarga" required>

                    <mat-option *ngFor = "let tipo of data.tipoCarga" value = "{{tipo.id}}">
                        
                        {{tipo.nombre}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>
        
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Sexo </mat-label>
                
                <mat-select name = "sexo" #sexo = "ngModel" [(ngModel)] = "carga.sexo" required>

                    <mat-option *ngFor = "let sexo of data.sexo" value = "{{sexo.id}}">
                        
                        {{sexo.descripcion}} 

                    </mat-option>

                </mat-select> 

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Parentesco </mat-label>
                
                <input name = "parentesco" matInput [(ngModel)] = "carga.parentesco" required 
                #parentesco = "ngModel" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fecha Ingreso </mat-label>
                
                <input name = "fechaIngreso" matInput type = "date" 
                [(ngModel)] = "carga.fechaIngreso" required #fechaIngreso = "ngModel"> 
                
            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fecha Nacimiento </mat-label>
                
                <input name = "fechaNacimiento" matInput type = "date" 
                [(ngModel)] = "carga.fechaNacimiento" required #fechaNacimiento = "ngModel"> 
                
            </mat-form-field>
        </p>       

        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fecha Expiración </mat-label>
                
                <input name = "fechaNacimiento" matInput type = "date" 
                [(ngModel)] = "carga.fechaExpiracion" required #fechaExpiracion = "ngModel"> 
                
            </mat-form-field>
        </p>
        
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">
                
                <mat-label> Fecha Defuncion </mat-label>
                
                <input name = "fechaDefuncion" matInput type = "date" 
                [(ngModel)] = "carga.fechaDefuncion"  #fechaDefuncion = "ngModel"> 
                
            </mat-form-field>
        </p>

 
    

    </mat-dialog-content> <br/> 

    <mat-dialog-actions>

        <button mat-button class = "mat-raised-button btn-success" (click) = "crearCarga()" [disabled] = "cargaForm.invalid"> 
            <i class = "fa fa-plus"> </i> Crear
        </button>
        
        <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()"> 
            <i class = "fa fa-trash"> </i> Salir
        </button>
        
    </mat-dialog-actions>

</form>